import classnames from 'classnames';
import {
    faScrewdriverWrench,
    faUnlockKeyhole,
    faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@/components/atoms/Button';

import styles from './index.module.css';

export interface ButtonGameStateProp {
    className?: string;
    status: 'contact' | 'open' | 'preparing' | 'closed';
    link?: string;
}

const ButtonGameState: React.FC<ButtonGameStateProp> = ({ className, status, link }) => {
    const Wrapper = status === 'contact' || (status === 'open' && link) ? 'a' : 'div';

    return (
        <Wrapper
            {...(status === 'contact' && { href: 'mailto:info@launcher.com.tw' })}
            {...(status === 'open' && link && { href: link, target: '_blank' })}
        >
            <Button
                className={classnames(className, styles.btn)}
                disabled={status !== 'open' && status !== 'contact'}
                hoverType="color"
            >
                <span className={styles.icon}>
                    {status === 'contact' && <FontAwesomeIcon icon={faEnvelope} />}
                    {status === 'open' && <FontAwesomeIcon icon={faUnlockKeyhole} />}
                    {status === 'preparing' && <FontAwesomeIcon icon={faScrewdriverWrench} />}
                    {status === 'closed' && <FontAwesomeIcon icon={faScrewdriverWrench} />}
                </span>
                <span>
                    {status === 'contact' && '來信詢問'}
                    {status === 'open' && '解鎖路線'}
                    {status === 'preparing' && '島民籌備中'}
                    {status === 'closed' && '路線關閉中'}
                </span>
            </Button>
        </Wrapper>
    );
};

export default ButtonGameState;
